const canvasSelector = document.querySelectorAll('#chartjs');
const computedStyle = getComputedStyle(document.documentElement);

function formatAbsoluteValue(label) {
  const units = [
    { value: 1e9, suffix: ' bil' },
    { value: 1e6, suffix: ' mil' },
    { value: 1e3, suffix: ' k' },
  ];

  for (const unit of units) {
    if (label >= unit.value) {
      return (label / unit.value).toFixed(2) + unit.suffix;
    }
  }

  return Number(label).toFixed(2);
}

const CHART_TYPE = {
  PIE: 'pie',
  BAR: 'bar',
};

const CHART = {
  TYPES: {
    'column-chart': CHART_TYPE.BAR,
    'pie-chart': CHART_TYPE.PIE,
  },
  COLORS: {
    income: ['#027A48', '#12B76A', '#6ed89c', '#bdf6d6'],
    outcome: [...Array(10)].map((_, i) =>
      getComputedStyle(document.documentElement)
        .getPropertyValue(`--color-chart-${i + 1}`)
        .replace(/\s+/g, ' ')
        .trim()
    ),
    //TODO remove this once later
    'budget-income': ['#027A48', '#12B76A', '#6ed89c', '#bdf6d6'],
    'budget-outcome': [
      '#6C1B1B',
      '#AC1719',
      '#b3292b',
      '#9B3737',
      '#974545',
      '#B16060',
      '#CD7D7D',
      '#FDA29B',
      '#E5B1B1',
      '#F1D5D5',
      '#FEF3F2',
    ],
  },
};
function ChartData({ dataset, parentElement }) {
  console.log(CHART.COLORS['outcome']);
  if (dataset.pageType === 'budget') {
    return this.budgetSchema(dataset);
  }

  this.legendElement = parentElement.parentElement;
  this.prepareData(dataset);

  if (!this.type) throw new Error('Invalid chart type: ' + dataset.chartType);
  if (!this.content) throw new Error('Invalid chart content: ' + dataset.content);
  if (!this.colorType) throw new Error('Invalid chart color type: ' + dataset.colorType);

  return this.generateCustomSchema();
}

ChartData.prototype.prepareData = function ({ chartType, content, colorType }) {
  this.type = CHART.TYPES[chartType];
  this.content = content && JSON.parse(content);
  this.colorType = colorType;
};

ChartData.prototype.generateCustomSchema = function () {
  return {
    type: this.type,
    data: this.generateData()[this.type].call(this),
    options: this.generateOptions()[this.type].call(this),
    plugins: this.generatePlugins()[this.type].call(this),
  };
};

ChartData.prototype.budgetSchema = function (dataset) {
  const colorType = `budget-${dataset.colorType}`;
  const values = JSON.parse(dataset.values);
  const labels = JSON.parse(dataset.labels);
  const data = {
    labels: labels,
    datasets: [
      {
        // label: 'Přišlo',
        data: values,
        backgroundColor: CHART.COLORS[colorType],
        hoverOffset: 4,
      },
    ],
  };

  return {
    type: 'pie',
    data: data,
    options: {
      plugins: {
        zoom: {
          limits: {
            y: { min: 0, max: 100 },
            y2: { min: -5, max: 5 },
          },
        },
        legend: {
          display: false,
        },
        tooltip: {
          titleFont: { weight: 'normal' },
          bodyFont: { weight: 'bold' },
          backgroundColor: '#ECFDF3',
          titleColor: '#0E0D0D',
          bodyColor: '#0E0D0D',
          displayColors: false,
          callbacks: {
            label: function (context) {
              const label = (Number(context.parsed) || 0).toFixed(2);
              const units = [
                { value: 1e9, suffix: ' bil' },
                { value: 1e6, suffix: ' mil' },
                { value: 1e3, suffix: ' k' },
              ];

              for (const unit of units) {
                if (label >= unit.value) {
                  return (label / unit.value).toFixed(2) + unit.suffix;
                }
              }

              return label;
            },
          },
        },
      },
    },
  };
};

ChartData.prototype.generatePlugins = function () {
  return {
    [CHART_TYPE.PIE]: function () {
      return [
        {
          beforeInit: (chart) => {
            if (chart.canvas.id === 'chartjs') {
              chart.canvas.addEventListener('mouseleave', () => {
                window.clearTimeoutLi = setTimeout(() => {
                  const legendItems = this.legendElement.querySelectorAll('li');
                  legendItems.forEach((li) => li.classList.remove('highlight'));
                }, 500);
              });

              const ul = document.createElement('ul');
              chart.data.labels.forEach((label, i) => {
                const li = document.createElement('li');
                li.setAttribute('data-index', i);

                li.innerHTML = `
                <span class="legend-block" style="background-color: ${chart.data.datasets[0].backgroundColor[i]}"></span>
                <span class="legend-text">${label}</span>
              `;
                li.style.cursor = 'pointer';

                li.addEventListener('click', (event) => {
                  const isVisible = !chart.isDatasetVisible(0) || chart.getDataVisibility(i);
                  chart.toggleDataVisibility(i);
                  chart.update();
                  li.style.textDecoration = isVisible ? 'line-through' : 'none';
                });

                ul.appendChild(li);
              });

              const legend = document.createElement('div');
              legend.classList.add('legend');
              legend.appendChild(ul);

              chart.canvas.parentElement.insertAdjacentElement('afterend', legend);
            }
          },
        },
      ];
    },
    [CHART_TYPE.BAR]: function () {
      return [
        {
          beforeInit: (chart) => {
            if (chart.canvas.id === 'chartjs') {
              const ul = document.createElement('ul');
              chart.data.datasets.forEach((dataset, i) => {
                const li = document.createElement('li');
                li.setAttribute('data-index', i);
                li.innerHTML = `
                <span class="legend-block" style="background-color: ${dataset.backgroundColor}"></span>
                <span class="legend-text">${dataset.label}</span>
              `;
                li.style.cursor = 'pointer';

                li.addEventListener('click', (event) => {
                  const isVisible = chart.isDatasetVisible(i);
                  chart.setDatasetVisibility(i, !isVisible);
                  chart.update();
                  li.style.textDecoration = isVisible ? 'line-through' : 'none';
                });

                ul.appendChild(li);
              });

              const legend = document.createElement('div');
              legend.classList.add('legend');
              legend.appendChild(ul);

              chart.canvas.parentElement.insertAdjacentElement('beforebegin', legend);
            }
          },
        },
      ];
    },
  };
};

ChartData.prototype.generateData = function () {
  return {
    [CHART_TYPE.PIE]: function () {
      const { items } = this.content;
      const data = { labels: [], datasets: [] };
      this.values = [];
      this.units = [];

      items.forEach((item) => {
        data.labels.push(item.name);
        this.values.push(item.value);
        this.units.push(item.unit);
      });

      data.datasets.push({
        data: this.values,
        backgroundColor: CHART.COLORS[this.colorType],
        hoverOffset: 4,
      });

      return data;
    },
    [CHART_TYPE.BAR]: function () {
      const { rows, columns } = this.content;
      const data = { labels: [], datasets: [] };
      const wrapper = this.legendElement.querySelector('.budget__chart');
      wrapper.width = 100;

      rows.forEach((row) => {
        data.labels.push(row.name);
      });

      columns.forEach((column, index) => {
        column.values.forEach(() => (wrapper.width += 50));

        data.datasets.push({
          label: column.name,
          data: column.values,
          backgroundColor: CHART.COLORS[this.colorType][index % CHART.COLORS[this.colorType].length],
        });
      });
      wrapper.style.width = `${wrapper.width}px`;

      return data;
    },
  };
};

ChartData.prototype.generateOptions = function () {
  const commonTooltipOptions = {
    padding: 10,
    titleFont: {
      weight: 'normal',
      size: 16,
    },
    bodyFont: {
      weight: 'bold',
      size: 16,
    },
    backgroundColor: '#FEF3F2',
    titleColor: '#3E3D3D',
    bodyColor: '#0E0D0D',
    displayColors: false,
  };

  return {
    [CHART_TYPE.PIE]: function () {
      return {
        plugins: {
          zoom: {
            limits: {
              y: { min: 0, max: 100 },
              y2: { min: -5, max: 5 },
            },
          },
          legend: {
            display: false,
            position: 'bottom',
            align: 'center',
            labels: {
              boxWidth: 20,
              padding: 10,
              font: {
                size: 14,
              },
              usePointStyle: false,
            },
          },
          tooltip: {
            ...commonTooltipOptions,
            callbacks: {
              title: () => {
                if (this.content.valueType === 1) return this.content.valueDescription;
              },
              label: (context) => helpers.getTooltip[this.content.valueType].apply(this, [context]),
            },
          },
        },
        onHover: (event, activeElements) => {
          if (window.clearTimeoutLi) clearTimeout(window.clearTimeoutLi);

          const legendItems = this.legendElement.querySelectorAll('li');
          legendItems.forEach((li) => li.classList.remove('highlight'));

          if (activeElements.length > 0) {
            const index = activeElements[0].index;
            const legendLi = this.legendElement.querySelector(`li[data-index="${index}"]`);
            if (legendLi) {
              legendLi.classList.add('highlight');
            }
          }
        },
      };
    },
    [CHART_TYPE.BAR]: function () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            bottom: 30,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            ...commonTooltipOptions,
            callbacks: {
              label: (context) => `${context.dataset.label}: ${formatAbsoluteValue(context.raw)}`,
            },
          },
        },
        scales: {
          x: {
            title: {
              display: false,
            },
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              padding: 30,
              callback: function (value) {
                const words = this.getLabelForValue(value).split(' ');
                const maxWordsPerLine = 2;
                const lines = [];
                for (let i = 0; i < words.length; i += maxWordsPerLine) {
                  lines.push(words.slice(i, i + maxWordsPerLine).join(' '));
                }
                return lines;
              },
              maxRotation: 0,
              minRotation: 0,
              font: {
                size: 16,
              },
            },
          },
          y: {
            beginAtZero: true,
            border: {
              display: false,
            },
            title: {
              display: false,
            },
            grid: {
              color: '#3E3D3D',
              lineWidth: 1,
            },
          },
        },
        elements: {
          bar: {
            borderRadius: { topLeft: 6, topRight: 6 },
            barThickness: 48,
          },
        },
      };
    },
  };
};

const helpers = {
  getTooltip: {
    1: function ({ parsed, dataIndex }) {
      return `${formatAbsoluteValue(parsed)} (${this.units[dataIndex]})`;
    },
    0: function ({ parsed, dataIndex }) {
      return `${parsed} (${this.units[dataIndex]})`;
    },
  },
};

if (canvasSelector.length > 0) {
  canvasSelector.forEach((canvas) => {
    const chartData = new ChartData(canvas);
    try {
      new Chart(canvas, chartData);
    } catch (error) {
      console.error('Failed to parse chart data: ' + error.message);
    }
  });
}
